import React from "react";

import { styled, Stack, Typography } from "@mui/material";
const Card = styled(Stack)(() => ({
  boxShadow: "5px 5px 50px rgba(0, 0, 0, 0.25)",
  height: "94px",
  backdropFilter: `blur(3px)`,
  backgroundColor: "rgba(255, 255, 255, 0.25)",
  border: "2px solid rgba(255, 255, 255, 0.27)",
  width: "272px",
  padding: `10px 20px`,
  borderRadius: "15px",
  "& .description": {
    overflowWrap: "break-word",
  },
}));

export interface CardInterface {
  title: string;
  description?: string;
  icon?: string;
}

const AnalyticsCard = ({
  title,
  description,
  icon = "far fa-boxes-alt",
}: CardInterface) => {
  return (
    <Card
      direction="row"
      justifyContent="space-around"
      alignItems="center"
      spacing={1.75}
    >
      <i className={`${icon} fa-2x font-white`} />
      <Stack spacing={0.75}>
        <Typography color="primary" variant="h5">
          {title}
        </Typography>
        <Typography color="white" variant="h6" className="description">
          {description}
        </Typography>
      </Stack>
    </Card>
  );
};
export default AnalyticsCard;
